// Update your JS

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getElement, ifSelectorExist } from "./utils";

export const GsapSnap = () => {
  if (window.innerWidth > 992) {
    gsap.registerPlugin(ScrollTrigger);

    const images = document.querySelectorAll(".gsap-bg-image");

    // Set initial z-index for each image to stack them properly
    images.forEach((image, index) => {
      gsap.set(image, { zIndex: images.length - index });
    });

    // Image Activation

    images.forEach((image, index) => {
      ScrollTrigger.create({
        trigger: `.panel:nth-child(${index + 3})`,
        start: "top center",
        end: "bottom center",
        onEnter: () => updateActiveImage(index),
        onEnterBack: () => updateActiveImage(index),
      });
    });

    function updateActiveImage(targetIndex) {
      images.forEach((img, imgIndex) => {
        img.classList.toggle("active", imgIndex === targetIndex);
      });

      // Update navigation line images based on current index
      const navImages = document.querySelectorAll(".navigation-line img");
      navImages.forEach((navImg, navIndex) => {
        navImg.classList.toggle("active", navIndex <= targetIndex);
      });
    }

    const startTrigElement = getElement(".start-trig");
    if (ifSelectorExist(startTrigElement)) {
      // Master Timeline for Pinning Background and Progress Lines
      const largeTL = gsap.timeline({
        scrollTrigger: {
          trigger: ".start-trig",
          pin: ".bg",
          pinSpacing: false,
          start: "top top",
          endTrigger: ".last",
          end: "bottom bottom",
          scrub: true,
          markers: false,
        },
      });

      // Progress Lines Animation
      const line1Inner = document.querySelector(".line-1 .progress-line-inner");
      const line2Inner = document.querySelector(".line-2 .progress-line-inner");

      largeTL
        .to(
          line1Inner,
          {
            height: "100%",
            ease: "none",
          },
          0
        )
        .to(
          line2Inner,
          {
            height: "100%",
            ease: "none",
          },
          0.5
        ); 
    }
  }
};
